import get from 'lodash.get';
import compact from 'lodash.compact';
import { getNavigationUrl } from '../../utils/shared/urlUtils';
import { INSTRUCTION } from '../../constants/shared/CommonConstants';

const { GROUPS, STUDENTS, ALL_ACTIVITIES } = INSTRUCTION;

const getInstructionTab = (tabId, location, url, optionalParams, popoverParams, hiddenTabIds) => {
    if (hiddenTabIds.includes(tabId)) return null;

    const tab = {
        id: tabId,
        path: getNavigationUrl(location, url, {
            instructionTab: tabId,
            ...optionalParams,
        }),
        title: tabId,
    };

    if (get(popoverParams, tabId)) {
        tab.popoverTitle = popoverParams[tabId].title;
        tab.popoverMessage = popoverParams[tabId].message;
    }

    return tab;
};

const getInstructionTabs = (location, url, optionalParams, popoverParams, hiddenTabIds) =>
    compact([
        getInstructionTab(GROUPS, location, url, optionalParams, popoverParams, hiddenTabIds),
        getInstructionTab(STUDENTS, location, url, optionalParams, popoverParams, hiddenTabIds),
        getInstructionTab(
            ALL_ACTIVITIES,
            location,
            url,
            optionalParams,
            popoverParams,
            hiddenTabIds,
        ),
    ]);

export default getInstructionTabs;
